/**
 * Animate scroll
 * @param  {jQ Object} $element
 * @return {Void}
 */

const animateScroll = ($element) => {
  $('html, body').animate(
    {
      scrollTop: $element.offset().top,
    },
    500
  );
};

// Currency submit form
$('.js-currency').on('change', function() {
  $(this).closest('form').trigger('submit');
});


// Login / Forgotten password toggle
$('.js-forgotten-pass, .js-loginform-link').on('click', function(e) {
  e.preventDefault();
  const $this = $(this);
  const targetString = $this.attr('href').replace('#', '');
  $(`.${targetString}`).show();
  $this
    .closest('form')
    .parent()
    .hide();
});

// Address new
$('.js-btn-new-address, .js-btn-new-address-cancel').on('click', function(e) {
  e.preventDefault();
  const $this = $(this);
  const $target = $(`.${$this.attr('href').replace('#', '')}`);

  $target.toggle().toggleClass('is-visible');

  if ($target.hasClass('is-visible')) {
    animateScroll($target);
  }
});

// Address edit
$('.js-link-edit-address').on('click', function(event) {
  event.preventDefault();

  const addressId = $(this).data('address-id');

  Shopify.CustomerAddress.toggleForm(addressId);
  animateScroll($(`#view_address_${addressId}`));
});

// Address delete
$('.js-link-delete-address').on('click', function(event) {
  event.preventDefault();

  Shopify.CustomerAddress.destroy($(this).data('address-id'), $(this).data('confirm-message'));
});

// Collection sortBy
$('.js-collection-sort-by').on('change', function() {
  Shopify.queryParams = {};
  const $this = $(this);
  const thisVal = $this.val();

  if (location.search) {
    const getArgumentsArray = location.search.substr(1).split('&');
    getArgumentsArray.map(function(ele) {
      const eleArray = ele.split('=');
      Shopify.queryParams[decodeURIComponent(eleArray[0])] = decodeURIComponent(eleArray[1]);
    });
  }

  Shopify.queryParams.sort_by = thisVal;
  location.search = $.param(Shopify.queryParams);
});

// Product price update
$('.js-product-main-select').on('change', function() {
  const $this = $(this);
  const $option = $this.find('option:selected');
  const $btnSubmit = $this.closest('form').find('input[type="submit"], button[type="submit"]');
  const thisPrice = $this.find('option:selected').data('price');

  $('.js-product-price').html(thisPrice);

  if ($option.is(':disabled')) {
    $btnSubmit.html(Shopify.theme.locale.products.product.sold_out).prop('disabled', true);
  } else {
    $btnSubmit.html(Shopify.theme.locale.products.product.add_to_cart).prop('disabled', false);
  }
});

// Address province option
$('select[name="address[country]"]').each(function() {
  const $this = $(this);
  const thisID = $this.attr('id');
  const province = $this.closest('form').find('select[name="address[province]"]');
  const provinceID = province.attr('id');
  const provinceHolderID = province.closest('.js-province-selector-holder').attr('id');
  new Shopify.CountryProvinceSelector(thisID, provinceID, {
    hideElement: provinceHolderID,
  });
});
